export default __webpack_public_path__ + "static/media/typeVan.59618589.59618589.svg";